import { Observable } from 'rxjs';

import { AppTheme } from '@core/shared/domain';

export abstract class AbstractThemeChangesTrackingService {
  abstract readonly themeChanges$: Observable<AppTheme>;
}
